import FileController, { TUploadedFile } from "~/client/http/FileController";

export const uploadFile = async (
  file: File,
  fallback: () => void
): Promise<TUploadedFile | undefined> => {
  const formData = new FormData();
  formData.append("file", file as File);
  const res = await FileController.upload(formData);
  if (res.status === 200 || res.status === 201) {
    return res.data;
  } else {
    fallback();
  }
};
